import React, { useState } from "react";
import TelegramUser from "../../../TelegramUser";
import { API_BASE_URL } from "../../../config";
import SuccessModal from "./SuccessModal";

const PaymentModal = ({ isOpen, onClose, onProceed, reservationId }) => {
  const [selectedMethod, setSelectedMethod] = useState("Telebirr");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");

  if (!isOpen) return null;

  const phonePrefix = selectedMethod === "Telebirr" ? "2519" : "2517";

  const handlePhoneNumberChange = (e) => {
    const input = e.target.value.replace(/\D/, "");
    if (input.length <= 9) {
      setPhoneNumber(input);
      setErrorMessage("");
    }
  };

  const validatePhoneNumber = () => {
    if (phoneNumber.length !== 8) {
      setErrorMessage("Phone number must be exactly 8 digits.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validatePhoneNumber()) return;

    const fullPhoneNumber = phonePrefix + phoneNumber; // Combine prefix and input

    setIsSubmitting(true);
    setErrorMessage("");

    const requestData = {
      paymentMethods: selectedMethod === "Telebirr" ? "TELEBIRR_USSD" : "MPESA",
      phoneNumber: fullPhoneNumber,
      username: TelegramUser.username,
    };

    try {
      const initData = window.Telegram.WebApp.initData;
      const response = await fetch(
        `${API_BASE_URL}/payment/api/v1/reservation_payment_for_min_app/${reservationId}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Telegram-InitData": initData,
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.status === 200) {
        const result = await response.json();
        setIsSuccess(true);
        setMessage(result.msg);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.Error || "Payment request failed");
      }
    } catch (error) {
      console.error("Payment error:", error);
      window.Telegram.WebApp.showAlert(
        "Payment request failed. please try again"
      );
      //alert("Payment request failed. please try again");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setPhoneNumber("");
    setSelectedMethod("Telebirr");
    setErrorMessage("");
    setIsSuccess(false);
    onClose();
  };

  return (
    <>
      {!isSuccess ? (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl p-4 w-80">
            <h3 className="text-center font-bold mb-4">
              Select Payment Method
            </h3>
            <form onSubmit={handleSubmit}>
              {/* Payment Methods */}
              <div className="flex flex-col space-y-2">
                {["Telebirr", "Mbesa"].map((method) => (
                  <label
                    key={method}
                    className={`flex justify-between items-center p-3 border ${
                      selectedMethod === method
                        ? "border-blue-500"
                        : "border-gray-300"
                    } rounded-lg cursor-pointer`}
                    onClick={() => setSelectedMethod(method)}
                  >
                    {method}
                    <div
                      className={`w-5 h-5 flex items-center justify-center border rounded-full ${
                        selectedMethod === method
                          ? "border-purple-500"
                          : "border-gray-300"
                      }`}
                    >
                      {selectedMethod === method && (
                        <div
                          className="w-3 h-3 rounded-full"
                          style={{ backgroundColor: "#6938ef" }}
                        ></div>
                      )}
                    </div>
                  </label>
                ))}
              </div>

              <div className="mt-4">
                <label className="block text-sm font-medium">
                  Phone Number
                </label>
                <div className="flex items-center border border-gray-300 rounded-lg mt-1">
                  <span className="p-2 bg-gray-200 rounded-l-lg">
                    +{phonePrefix}
                  </span>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    className="w-full p-2 border-none outline-none rounded-r-lg"
                    placeholder="Enter last 8 digits"
                  />
                </div>
                {errorMessage && (
                  <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex justify-between mt-4">
                <button
                  type="submit"
                  className="w-1/2 py-2 text-white rounded-xl mr-2"
                  style={{ backgroundColor: "#6938ef" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Processing..." : "Proceed"}
                </button>
                <button
                  type="button"
                  className="w-1/2 py-2 border border-black text-black rounded-xl"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <SuccessModal
          message={message}
          onClose={() => {
            onClose();
          }}
        />
      )}
    </>
  );
};

export default PaymentModal;
